import { Box, Button, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { MaterialReactTable } from 'material-react-table'
import { Edit, History } from "@mui/icons-material";
import RawInventoryModal from "../../../components/modals/RawInventoryModal";


function RawInventoryTable(props) {

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleHistoryClick = (row) => {
    console.log("History icon clicked for row:", row.original);
    setOpen(true);
  };
  return (
    <>
    <MaterialReactTable
    enableStickyHeader
    muiTableContainerProps={{ sx: { maxHeight: '500px' } }}
    displayColumnDefOptions={{
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      size: 120,
    },
  }}
  columns={props.columns}
  data={props.tableData}
  editingMode="modal"
  enableColumnOrdering
  enableEditing
  onEditingRowSave={props.handleSaveRowEdits}
  onEditingRowCancel={props.handleCancelRowEdits}
  renderRowActions={({ row, table }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent:'center',
        gap: "1rem",
      }}
    >
      <Tooltip arrow placement="right" title="History">
        <IconButton onClick={() => handleHistoryClick(row)}>
          <History />
        </IconButton>
      </Tooltip>
    </Box>
  )}
  renderTopToolbarCustomActions={() => (
<Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems='flex-start' margin={"5px"}>
  <Button
    onClick={() => props.setCreateModalOpen(true)}
    variant="contained"
    sx={{mx: 1}}// Add margin between buttons
  >
     RawMetarial ADD
  </Button>

  <Button
    onClick={() => props.setSubtractModalOpen(true)}
    style={{
      backgroundColor: "#1976D2",
      color: "white",
      marginLeft:"2rem",
    }}
    variant="contained"
    sx={{mx: 1}}
  >
     RawMetarial Subtract
  </Button>
</Box>

  )}
/>
<RawInventoryModal open={open} handleClose={handleClose}/>
</>

  );
}

export default RawInventoryTable;
